import { createIcon } from "@chakra-ui/react";

export const Award = createIcon({
  displayName: "Award",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 0a3 3 0 0 1 3 3v20.25a.75.75 0 0 1-1.11.658L12 19.605l-7.89 4.303A.75.75 0 0 1 3 23.25V3a3 3 0 0 1 3-3h12zm-5.76 6.148a.267.267 0 0 0-.48 0l-.951 1.93a.266.266 0 0 1-.2.146l-2.13.31a.267.267 0 0 0-.148.454l1.541 1.502c.063.061.09.15.076.236l-.363 2.12a.267.267 0 0 0 .387.282l1.904-1.001c.078-.04.17-.04.248 0l1.904 1a.267.267 0 0 0 .387-.28l-.363-2.121a.267.267 0 0 1 .076-.236l1.54-1.502a.267.267 0 0 0-.146-.455l-2.13-.31a.266.266 0 0 1-.2-.145l-.953-1.93z"
    />,
  ],
  defaultProps: {
    "aria-label": "A ribbon shape with a star within"
  }
});

export default Award;
